/*
 * /therapy/session (page)
 */
import { createFileRoute } from "@tanstack/react-router"
import { Container, Divider, Page, PageHeader } from "@psychology/react-ui"
import { ArrowLeft } from "lucide-react"
import { v4 as uuidv4 } from "uuid"
import { TherapySessionsList } from "../../../features/therapy/components/therapy-session-list"
import { trpc } from "../../../trpc"
import { authPageLoader } from "../../../utils/auth.utils"

export const Route = createFileRoute("/therapy/session/")({
	component: TherapySessionsPage,
	loader: authPageLoader,
})

function TherapySessionsPage() {
	const { user } = Route.useLoaderData()

	const { data: therapySessions, isLoading } =
		trpc.therapySession.getAllByFilter.useQuery({
			where: { userId: user.id },
		})

	return (
		<Page centerVertical={false}>
			<Container width={"xl"} padding={"lg"} gap={"sm"}>
				<PageHeader
					title={"Theray Sessions"}
					left={{
						href: "/dashboard",
						label: "Dashboard",
						Icon: <ArrowLeft size={20} />,
					}}
				/>
				<Divider />
				<div className={"space-y-6"}>
					{isLoading ? (
						<div className={"text-center"}>{"Loading..."}</div>
					) : (
						<TherapySessionsList
							therapySessions={therapySessions || []}
							newId={uuidv4()}
						/>
					)}
				</div>
			</Container>
		</Page>
	)
}
